import ecosystem from './ecosystemState';

const initialState = {
  ecosystem,
  dashboard: {
    currentTask: 'Monitoring agent constellation',
    tokenUsage: 860,
    timeSpent: 32
  },
  project: {
    progress: 35,
    timeline: ['Deploy v0.1', 'Wire telemetry', 'Run CI'],
    todos: [
      { id: 1, text: 'Map agent states', done: true },
      { id: 2, text: 'Wire telemetry pulse', done: true },
      { id: 3, text: 'Tune signal feeds', done: false }
    ]
  }
};

export default initialState;
